var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#597592",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.732 5.296c-.188-.19-.443-.296-.71-.296-.267 0-.522.106-.71.296l-7.45 7.46-3.13-3.14c-.263-.254-.64-.348-.992-.248-.35.101-.621.381-.71.735-.088.355.02.73.282.983l3.84 3.84c.188.19.443.296.71.296.267 0 .522-.107.71-.296l8.16-8.16c.205-.19.322-.456.322-.735 0-.28-.117-.546-.322-.735z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.41572c88854f67572e1f88f35da1fa20.svg";
export { ForwardRef as ReactComponent };